import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { isEnterPressed } from '../../helpers';


const styles = theme => ({
  textField: {
    justifySelf: 'flex-end',
    
  },
  input: {
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
      padding: 12
    },
  },
  hideOutline: {
    border: 'none',
  }
});

class SearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.input = React.createRef();
    this.state = {
      searchText: '',
    };
  }

  handleChange = e => {
    this.setState({searchText: e.target.value});
  }

  handleClose = () => {
    this.setState((state, props) => {
      const { show, toggleSearchBar } = props;
      if (show && state.searchText !== '') {
          return {searchText: ''}
      } else {
        toggleSearchBar(!show);
      }
    });
  };

  handleKeyPress = e => {
    if (isEnterPressed(e)) {
      const { show } = this.props;
      const { searchText } = this.state;
      if (show && searchText !== '') {
        window.location.href = `/product-search/?q=${searchText}`
      }
    }
  };  

  handleSearchClick = () => {
    const { show, toggleSearchBar } = this.props;
    const { searchText } = this.state;
    if (show && searchText !== '') {
      window.location.href = `/product-search/?q=${searchText}`
    } else {
      toggleSearchBar(!show, () => {
        if (!show) {
          this.input.current.focus();
        }
      });
    }
  };

  render() {
    const { classes, show } = this.props;
    const { searchText } = this.state;

    return (
        <TextField
          placeholder="What are you looking for?"
          classes={{root: classes.root}}
          className={classes.textField}
          onChange={this.handleChange}
          margin="normal"
          value={searchText}
          variant='outlined'
          fullWidth={show}
          style={{
            width: show ? undefined : 155,
            transition: 'all .3s ease',
          }}
          inputProps={{
            className: classes.input,
            onKeyPress: this.handleKeyPress,
            style: {
              visibility: show ? undefined : 'hidden',
            },
          }}
          InputProps={{
            classes: {
              notchedOutline: show ? classes.showOutline : classes.hideOutline,
            },
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="Close"
                  onClick={this.handleClose}
                  style={{visibility: show ? undefined : 'hidden'}}
                >
                  <CloseIcon />
                </IconButton>
                <IconButton
                  aria-label="Search"
                  onClick={this.handleSearchClick}
                  color='primary'
                >
                  <SearchIcon/>
                </IconButton>
              </InputAdornment>
            ),
          }}
          inputRef={this.input}
        />
    )
  }
}

SearchBar.propTypes = {
  classes: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  toggleSearchBar: PropTypes.func.isRequired,
};

export default withStyles(styles)(SearchBar);